var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"animated fadeIn",attrs:{"pill":"","variant":_vm.variant}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.value || "N/A"))]):_c('i',{staticClass:"fa fa-spin fa-spinner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }